import { connect } from "react-redux";
import { commonStyle } from "../../../../assets/css/css";
import { HiRefresh } from "react-icons/hi";
import Topbar from "../../../../common/component/topbar/Topbar";
import Sidebar from "../../../../common/componentV2/sidebar/Sidebar";
import PreLoader from "../../../../common/component/preLoader/PreLoader";
import React, { useEffect, useState } from 'react'
import DataCard from '../component/DataCard';
import BusyHoursGraph from '../component/BusyHoursChart';
import AgentActivityGraph from "../component/AgentActivityChart";
import LineChart from '../component/LineChart';
import '../styles/HistoricalStats.css';
import { GET } from "../../../../services/HttpRequests";
import { toast } from "react-toastify";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@material-ui/core";

const moment = require('moment-timezone');
const analyticsUrl = process.env.REACT_APP_ANALYTICS_API;

function CallStatusComponent({ dates = [], data = {} }) {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [chartData, setChartData] = useState({ labels: dates, datasets: [] });

  useEffect(() => {
    const totalCallsLine = {
      label: 'Total Calls',
      data: data.totalCalls || [],
      borderColor: '#384AE7',
      backgroundColor: '#384AE7',
      pointBackgroundColor: '#384AE7',
      pointBorderColor: 'transparent',
      pointRadius: 2,
      pointHoverRadius: 6,
      tension: 0.4,
    };

    const incomingCallsLine = {
      label: 'Incoming Calls',
      data: data.incomingCalls || [],
      borderColor: '#E7793A',
      backgroundColor: '#E7793A',
      pointBackgroundColor: '#E7793A',
      pointBorderColor: 'transparent',
      pointRadius: 2,
      pointHoverRadius: 6,
      tension: 0.4,
    };

    const outgoingCallsLine = {
      label: 'Outgoing Calls',
      data: data.outgoingCalls || [],
      borderColor: '#E7366B',
      backgroundColor: '#E7366B',
      pointBackgroundColor: '#E7366B',
      pointBorderColor: 'transparent',
      pointRadius: 2,
      pointHoverRadius: 6,
      tension: 0.4,
    };

    const filterMap = {
      all: [totalCallsLine, incomingCallsLine, outgoingCallsLine],
      incoming: [incomingCallsLine],
      outgoing: [outgoingCallsLine],
    };

    setChartData({ labels: dates, datasets: filterMap[selectedFilter] });
  }, [dates, data, selectedFilter]);

  return (
    <div className='CallStatusComponent'>
      <div className='CallStatusComponentHeader'>
        <div className='CallStatusHeader'>Call Volume</div>
        <div className='GraphFilterTable'>
          {['All', 'Incoming', 'Outgoing'].map((filter) => (
            <div
              key={filter}
              className={selectedFilter === filter.toLowerCase() ? 'GraphFilterTableSelected' : 'GraphFilterTableNotSelected'}
              onClick={() => setSelectedFilter(filter.toLowerCase())}
            >
              {filter}
            </div>
          ))}
        </div>
      </div>
      <div className="ChartWrapper">
        <LineChart data={chartData} />
      </div>
    </div>
  );
}

function AverageCallDuration({ dates = [], data = {} }) {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [chartData, setChartData] = useState({ labels: dates, datasets: [] });

  useEffect(() => {
    const totalCallsLine = {
      label: 'Total Calls',
      data: data.totalCallsAvg || [],
      borderColor: '#384AE7',
      backgroundColor: '#384AE7',
      pointBackgroundColor: '#384AE7',
      pointBorderColor: 'transparent',
      pointRadius: 2,
      pointHoverRadius: 6,
      tension: 0.4,
    };

    const incomingCallsLine = {
      label: 'Incoming Calls',
      data: data.incomingCallsAvg || [],
      borderColor: '#E7793A',
      backgroundColor: '#E7793A',
      pointBackgroundColor: '#E7793A',
      pointBorderColor: 'transparent',
      pointRadius: 2,
      pointHoverRadius: 6,
      tension: 0.4,
    };

    const outgoingCallsLine = {
      label: 'Outgoing Calls',
      data: data.outgoingCallsAvg || [],
      borderColor: '#E7366B',
      backgroundColor: '#E7366B',
      pointBackgroundColor: '#E7366B',
      pointBorderColor: 'transparent',
      pointRadius: 2,
      pointHoverRadius: 6,
      tension: 0.4,
    };

    const filterMap = {
      all: [totalCallsLine, incomingCallsLine, outgoingCallsLine],
      incoming: [incomingCallsLine],
      outgoing: [outgoingCallsLine],
    };

    setChartData({ labels: dates, datasets: filterMap[selectedFilter] });
  }, [dates, data, selectedFilter]);

  return (
    <div className='CallStatusComponent'>
      <div className='CallStatusComponentHeader'>
        <div className='CallStatusHeader'>Average Call Duration (sec) </div>
        <div className='GraphFilterTable'>
          {['All', 'Incoming', 'Outgoing'].map((filter) => (
            <div
              key={filter}
              className={selectedFilter === filter.toLowerCase() ? 'GraphFilterTableSelected' : 'GraphFilterTableNotSelected'}
              onClick={() => setSelectedFilter(filter.toLowerCase())}
            >
              {filter}
            </div>
          ))}
        </div>
      </div>
      <div className="ChartWrapper">
        <LineChart data={chartData} />
      </div>
    </div>
  );
}

function BusyHoursComponent() {
  const labelsMap = { 0: "12a", 1: "1a", 2: "2a", 3: "3a", 4: "4a", 5: "5a", 6: "6a", 7: "7a", 8: "8a", 9: "9a", 10: "10a", 11: "11a", 12: "12p", 13: "1p", 14: "2p", 15: "3p", 16: "4p", 17: "5p", 18: "6p", 19: "7p", 20: "8p", 21: "9p", 22: "10p", 23: "11p" };

  const today = moment.tz("Asia/Kolkata").format("YYYY-MM-DD");
  const [data, setData] = useState([]);
  const [date, setDate] = useState(today);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async (filterDate) => {
    try {
      setIsLoading(true);
      let data = {
        organisationId: localStorage.getItem('doosra-biz-organisation-id'),
        date: filterDate || date
      };
      await GET(analyticsUrl + 'v1/analytics/busy-hours-data', data)
        .then((res) => {
          const busyHoursData = res?.data?.response?.busyHoursData || {};
          const apiData = Object.entries(busyHoursData).map(([key, value]) => ({
            label: labelsMap[key],
            value: value,
          }));
          setData(apiData);
          setDate(res?.data?.response?.date || date);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } catch (err) {
      toast.error("Unable to load data!!!");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className='AgentActivityComponent'>
      <div className='CallStatusComponentHeader'>
        <div className='CallStatusHeader'>Busy Hours</div>
        <div className='HistoricalMetricsFilter'>
          <div className='HistoricalFilterHeader'>FILTER</div>
          <div>
            <input
              type="text"
              className='HistoricalDateFilter'
              value={date}
              onChange={(e) => setDate(e.target.value)}
              placeholder={!date ? "Select from date" : date}
              onClick={(e) => e.target.type = "date"}
            />
          </div>
          <div>
            <button
              className="FilterSearchButton"
              onClick={() => fetchData(date)}
            >
              SEARCH
            </button>
          </div>
        </div>
      </div>
      <div className='BusyHoursGraphContainer'>
        <BusyHoursGraph
          data={data}
        />
      </div>
    </div>
  )
}

function AgentActivityComponent() {
  const [data, setData] = useState([]);
  const [date, setDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState([]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      let data = {
        organisationId: localStorage.getItem('doosra-biz-organisation-id'),
        date: date,
        agentIds: '67331cd964ec761eb40bc035'
      };
      await GET(analyticsUrl + 'v1/analytics/agent-activity', data)
        .then((res) => {
          const agentActivityData = res?.data?.response?.agentActivityData || {};
          setData(agentActivityData);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } catch (err) {
      toast.error("Unable to load data!!!");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className='AgentActivityComponent'>
      <div className='CallStatusComponentHeader'>
        <div className='CallStatusHeader'>Agent Activity</div>
        <div className='HistoricalMetricsFilter'>
          <div className='HistoricalFilterHeader'>FILTER</div>
          <div>
            {/* <select
              className='HistoricalDateFilter'
              value={selectedAgent.length ? selectedAgent : [""]}
              onChange={(e) => {
                const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value);
                setSelectedAgent(selectedOptions);
              }}
              multiple
            >
              <option value="" disabled hidden>Select Agent</option>
              <option value="akhil">Akhil</option>
              <option value="akhil2">Akhil2</option>
            </select> */}
            <Select
              multiple
              value={selectedAgent}
              onChange={(e) => setSelectedAgent(e.target.value)}
              input={<OutlinedInput />}
              displayEmpty
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return <em style={{ fontSize: '12px', fontStyle: "normal" }}>Select Agent</em>;
                }
                return selected.join(', ');
              }}
              className="AgentActivityAgentsFilter"
            >
              <MenuItem disabled value="">
                <em>Select Agent</em>
              </MenuItem>
              <MenuItem value="akhil">Akhil</MenuItem>
              <MenuItem value="akhil2">Akhil2</MenuItem>
            </Select>
          </div>
          <div>
            <input
              type="text"
              className='HistoricalDateFilter'
              value={date}
              onChange={(e) => setDate(e.target.value)}
              placeholder={!date ? "Select from date" : date}
              onClick={(e) => e.target.type = "date"}
            />
          </div>
          <div>
            <button
              className="FilterSearchButton"
              onClick={fetchData}
            >
              SEARCH
            </button>
          </div>
        </div>
      </div>
      <div className='BusyHoursGraphContainer'>
        <AgentActivityGraph
          labels={data?.map(item => item.name)}
          datasets={[
            {
              label: 'Busy Time',
              data: data?.map(item => item.busyTime),
              backgroundColor: '#28A745',
            },
            {
              label: 'Meeting / Training',
              data: data?.map(item => item.workBreaks),
              backgroundColor: '#6C757D',
            },
            {
              label: 'Break',
              data: data?.map(item => item.normalBreaks),
              backgroundColor: '#E7366B',
            },
          ]}
        />
      </div>
    </div>
  )
}

function HistoricalDataComponent() {
  const [isLoading, setIsLoading] = useState(false);
  const [historicalData, setHistoricalData] = useState({});
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleChange = (e, key) => {
    if (key === 'from') {
      setFromDate(e.target.value);
    }
    if (key === 'to') {
      setToDate(e.target.value);
    }
  };

  const handleSearch = (e) => {
    if (fromDate && toDate) {
      fetchHistoricalData(fromDate, toDate);
    } else {
      toast.error("Provide Inputs!!!")
    }
  };

  const fetchHistoricalData = async (fromDate, toDate) => {
    try {
      setIsLoading(true);
      let data = { fromDate, toDate };
      console.log(JSON.stringify(data));
      data.organisationId = localStorage.getItem('doosra-biz-organisation-id');
      await GET(analyticsUrl + 'v1/analytics/historical-data', data)
        .then((res) => {
          setHistoricalData(res.data.response.historicalData);
          setIsLoading(false);
          setFromDate(fromDate);
          setToDate(toDate);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } catch (err) {
      toast.error("Unable to load data!!!");
    }
  };

  useEffect(() => {
    const oneWeekBack = moment.tz("Asia/Kolkata").subtract(1, 'week').format("YYYY-MM-DD");
    const toDay = moment.tz("Asia/Kolkata").format("YYYY-MM-DD");
    fetchHistoricalData(oneWeekBack, toDay);
  }, []);

  return <div>
    <div className='LiveStatsHeader'>
      <div className='HistoricalStatsHeader'>HistoricalStats</div>
      <div className='HistoricalMetricsFilter'>
        <div className='HistoricalFilterHeader'>FILTER</div>
        <div>
          <input
            type="text"
            className='HistoricalDateFilter'
            value={fromDate}
            onChange={(e) => handleChange(e, "from")}
            placeholder={!fromDate ? "Select from date" : fromDate}
            onClick={(e) => e.target.type = "date"}
          />
          &nbsp;
          <input
            type="text"
            className='HistoricalDateFilter'
            value={toDate}
            onChange={(e) => handleChange(e, "to")}
            placeholder={!toDate ? "Select to date" : toDate}
            onClick={(e) => e.target.type = "date"}
          />
        </div>
        <div>
          <button
            className="FilterSearchButton"
            onClick={handleSearch}
          >
            SEARCH
          </button>
        </div>
      </div>
    </div>
    <div className="AgentStatusDataCardsContainer">
      <DataCard
        title="Total Calls"
        count={historicalData?.totalCalls || 0}
      />
      <DataCard
        title="Incoming Calls"
        count={historicalData?.incomingTotalCalls || 0}
      />
      <DataCard
        title="Outgoing Calls"
        count={historicalData?.outgoingTotalCalls || 0}
      />
    </div>
    <div className='CallGraphs'>
      <CallStatusComponent
        dates={historicalData?.dates || []}
        data={historicalData?.callStatusGraphDetails || {}}
      />
      <AverageCallDuration
        dates={historicalData?.dates || []}
        data={historicalData?.avgDurationGraphDetails || {}}
      />
    </div>
  </div>
}

function HistoricalStats(props) {
  return (
    <div className={`${props.className}`}>
      <Topbar />
      <div style={{ display: 'flex', height: 'calc(100vh - 72px)' }}>
        <Sidebar />
        <div className="PageContainer">
          <div className='HistoricalStats'>
            <HistoricalDataComponent />
            {/* <div className='AgentActivityContainer'>
              <AgentActivityComponent />
            </div> */}
            <div className='BusyHoursContainer'>
              <BusyHoursComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


const mapStateToProps = (state) => ({
  sidebarClosed: state.sidebar.sidebarClosed,
  userDetails: state.recovery.userDetails,
});

export default commonStyle(connect(mapStateToProps, {})(HistoricalStats));
